import { DomainLandingPageIcon, CalendarCheckIcon, CalendarIcon } from "@shopify/polaris-icons";

const settingConfig = (cms) => {
  const config = {
    "/": [
      {
        caption: cms("common.actions.dashboard.caption.customDomain"),
        label: cms("common.actions.dashboard.label.customDomain"),
        link: "/domain",
        icon: DomainLandingPageIcon,
      },
      {
        caption: cms("common.actions.dashboard.caption.featurePlan"),
        label: cms("common.actions.dashboard.label.featurePlan"),
        link: "/feature",
        icon: CalendarIcon,
      },
      {
        caption: cms("common.actions.dashboard.caption.plan"),
        label: cms("common.actions.dashboard.label.plan"),
        link: "",
        icon: CalendarCheckIcon,
      },
    ],
  };

  const title = {
    "/": cms("common.actions.title.setting"),
    "/orders": cms("common.actions.title.orderSettings"),
    "/payments": cms("common.actions.title.paymentSettings"),
    "/products": cms("common.actions.title.productSettings"),
    "/providers": cms("common.actions.title.vendorSettings"),
  };

  return { config, title };
};

export default settingConfig;
